import { Button, Tooltip } from "@mui/material";
import { useState } from "react";
import HandleSendTilaustiedotModal from "src/components/comms/SendTilaustiedotButton/HandleSendTilaustiedotModal";
import PropTypes from "prop-types";
import ShareIcon from "@mui/icons-material/Share";

export default function SendTilaustiedotButton(props) {
  const keikkaData = props.keikkaData;

  const showIcon = props.showIcon || false;
  const buttonText = props.buttonText || "";
  const toolTipText = props.toolTipText || "";
  const isLoading = keikkaData.isLoading;
  const [isTilaustiedotOpen, setIsTilaustiedotOpen] = useState(false);
  const handleTilaustiedotClose = () => setIsTilaustiedotOpen(false);
  const handleSendTilaustiedotKlik = () => {
    setIsTilaustiedotOpen(true);
  };
  return (
    <div className="noPrint">
      <HandleSendTilaustiedotModal
        open={isTilaustiedotOpen}
        close={handleTilaustiedotClose}
        keikkaData={keikkaData}
      />

      <Tooltip title={toolTipText} placement="bottom-end" arrow disableInteractive>
        <Button
          variant="outlined"
          onClick={handleSendTilaustiedotKlik}
          className={buttonText ? "toiminnotButton" : ""}
          disabled={isLoading}
          sx={{ height: "40px" }}
          aria-label="Avaa tilaustietojen lähetys">
          <>
            {buttonText}
            {showIcon && <ShareIcon color="primary" />}
          </>
        </Button>
      </Tooltip>
    </div>
  );
}

SendTilaustiedotButton.propTypes = {
  keikkaData: PropTypes.object,
  buttonText: PropTypes.string,
  toolTipText: PropTypes.string,
  showIcon: PropTypes.bool,
  isLoading: PropTypes.bool,
};
